<template>
  <div>
    <div v-if="!winners.length" :class="defaultTextColor">
      <h3>
        <strong class="title">Inscrições Encerradas </strong><br>
      </h3>
      <p>
        O período de inscrições para o nosso concurso chegou ao fim. Agradecemos a todos que participaram! Boa sorte! <br>
        <br>
        <strong>Data do sorteio:</strong> <br>
        {{ drawDate }} às {{ drawTime }}
      </p>
    </div>
    <div v-else :class="defaultTextColor">
      <h3>
        <strong class="title">Vencedores Selecionados!</strong><br>
      </h3>
      <p>
        Parabéns aos sortudos vencedores do nosso sorteio! As inscrições estão agora encerradas. Agradecemos a todos que
        participaram e compartilhamos nossa alegria pelos vencedores. Continue nos acompanhando para futuras
        oportunidades! <br>
        <br>
      </p>
      <h4>
        <strong class="title">Ganhadores:</strong><br>
      </h4>
      <ul>
        <li v-for="winner in winners">
          {{ winner }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  computed: {
    defaultTextColor() {
      return this.$store.state.template.style.defaultTextColor ? this.$store.state.template.style.defaultTextColor : 'text-white'
    },
    winners() {
      return this.$store.getters.getDrawWinners
    },
    drawDate() {
      return this.$store.getters.getDrawDate
    },
    drawTime() {
      return this.$store.getters.getDrawTime
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 2rem;
}
p {
  font-size: 1.2rem;
}
li {
  list-style-position: inside;
}
</style>
